import type { RequestPolicy } from 'urql';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useIsLoggedIn } from '../../context/AuthMachine';
import { useGetOrderStatusNotificationPreferencesQuery } from './graphql/GetOrderStatusNotificationPreferences.generated';

// ─────────────────────────────────────────────────────────────────────

export const useOrderStatusNotificationPreferences = (params: Params = {}) => {
  const { requestPolicy, pause } = params;

  const isLoggedIn = useIsLoggedIn();
  const isNotificationPreferencesEnabled = useFeatureFlag(
    'CELS-3674-enable-notification-preference-center',
  );

  const [{ data, fetching, error }, refetch] =
    useGetOrderStatusNotificationPreferencesQuery({
      requestPolicy,
      pause: pause || !isNotificationPreferencesEnabled || !isLoggedIn,
    });

  const { getOrderStatusNotificationPreferences: preferences } = data ?? {};

  return {
    refetch,
    isPushSubscribed: preferences?.pushSubscribe ?? true,
    isEmailSubscribed: preferences?.emailSubscribe ?? true,
    isFeatureEnabled: isNotificationPreferencesEnabled,
    error,
    fetching,
  };
};

// ─── Types ───────────────────────────────────────────────────────────

type Params = {
  requestPolicy?: RequestPolicy;
  pause?: boolean;
};
